import { gql } from "@apollo/client";

export const CREATE_FILE = gql`
  mutation CreateFile($input: CreateFileInput!) {
    createFile(input: $input) {
      file {
        id
        authorId
        fileCategory
        type
        mimeType
        url
        publicUrl
        key
        size
        description
        summary
        data
        aiFileId
        status
        isPublic
        uploadedAt
        createdAt
        updatedAt
        ref {
          id
          collection
        }
        domain
        isSystem
      }
    }
  }
`;

export const UPDATE_FILE = gql`
  mutation UpdateFile($input: UpdateFileInput!) {
    updateFile(input: $input) {
      file {
        id
        authorId
        fileCategory
        type
        mimeType
        url
        publicUrl
        key
        size
        description
        summary
        data
        aiFileId
        status
        isPublic
        uploadedAt
        createdAt
        updatedAt
        ref {
          id
          collection
        }
        domain
        isSystem
      }
    }
  }
`;

export const DELETE_FILE = gql`
  mutation DeleteFile($id: ID!, $authorId: String!) {
    deleteFile(id: $id, authorId: $authorId) {
      id
    }
  }
`;

export const INGEST_PROPERTY_FILE = gql`
  mutation IngestPropertyFile($input: IngestPropertyFileInput!) {
    ingestPropertyFile(input: $input) {
      queued
      fileId
    }
  }
`;

export const UPLOAD_FILE_TO_OPENAI = gql`
  mutation UploadFileToOpenAI($id: ID!, $authorId: String!) {
    uploadFileToOpenAI(id: $id, authorId: $authorId) {
      file {
        id
        authorId
        fileCategory
        type
        mimeType
        url
        publicUrl
        key
        size
        description
        summary
        data
        aiFileId
        status
        isPublic
        uploadedAt
        createdAt
        updatedAt
        ref {
          id
          collection
        }
        domain
        isSystem
      }
    }
  }
`;
